import React, { useEffect, useRef } from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../library/layout/Index";
import WorkflowStages from './WorkflowStages';

const Workflow = (props) => {
    const { formObject } = props;
    const workflowView = formObject?.childViewsV5?.workflowView?.viewData || null;
    const workflowContainerRef = useRef(null);
    const currentStageRef = useRef(null);

    // console.log("DesignWorkflow workflowView", formObject);

    useEffect(() => {
        if (!workflowView?.currentStageKey) {
            return;
        }

        const container = workflowContainerRef.current;
        const currentStageNode = currentStageRef.current;

        if (!container || !currentStageNode) {
            return;
        }

        // Keep the active stage centered in the workflow rail as status progresses.
        window.requestAnimationFrame(() => {
            const targetTop = currentStageNode.offsetTop - (container.clientHeight / 2) + (currentStageNode.offsetHeight / 2);

            container.scrollTo({
                top: Math.max(0, targetTop),
                behavior: 'smooth'
            });
        });
    }, [workflowView?.currentStageKey, workflowView?.stageList?.length]);

    if (!workflowView)
        return (null);

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Workflow' />
                    </span>
                </UiTitle>
                <UiAction>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <div className="uiWorkflowStages" ref={workflowContainerRef}>
                    <WorkflowStages
                        formObject={formObject}
                        workflowView={workflowView}
                        currentStageRef={currentStageRef}
                    />
                </div>
            </UiViewContent>
        </UiView >
    )
}

export default withView(Workflow, "v5WorkFlow", "v5WorkFlow,taskHead,taskDetail")
